export const th = {
    "TRIGGER_LISTEN": "ฟังการกระตุ้น",
    "ASSIST_EMPTY_MSG": "เอเจนต์ AI กำลังฟังการสนทนาของคุณและพร้อมที่จะช่วยเหลือโดยอัตโนมัติเมื่อได้รับการกระตุ้น",
    "MYBOT_TRIGGET_LISTEN": "ไม่มีงาน My Bot ที่ทำงานอยู่ในขณะนี้",
    "MYBOT_EMTPY_MSG": "เพื่อเริ่มงานใน My Bot ให้ไปที่แท็บค้นหาและเลือกตัวเลือก \"รันด้วยข้อมูลจากเอเจนต์\" สำหรับงานที่คุณต้องการ",
    "PROACTIVE_MODE": "โหมดเชิงรุก",
    "SETTINGS": "การตั้งค่า",
    "HELP_AND_SUPPORT": "ช่วยเหลือและสนับสนุน",
    "HELP": "ช่วยเหลือ",
    "LANGUAGE": "ภาษา",
    "THEME": "ธีม",
    "AUTOMATIC": "อัตโนมัติ",
    "FILE_NAME":"ชื่อไฟล์",
    "DARK": "มืด",
    "AUTO_SCROLL_TOOLTIP":"ควบคุมการเลื่อนอัตโนมัติของแท็บช่วยเหลือ, บอทของฉัน และเนื้อหาแท็บถอดเสียง",
    "LIGHT": "สว่าง",
    "THEME_DESC": "จะใช้โหมดเริ่มต้นของระบบของคุณ",
    "DOCUMENTATION": "เอกสาร",
    "DOC_DESC": "ตรวจสอบบทความเอกสารเชิงลึกของเรา",
    "FAQ_U": "คำถามที่พบบ่อย",
    "FAQ_DESC": "ตรวจสอบคำถามที่พบบ่อยเกี่ยวกับ Agent AI",
    "KORE_ACADEMY": "Kore Academy",
    "KORE_ACA_DESC": "เรียนรู้เพิ่มเติมเกี่ยวกับ Agent AI โดยการเข้าชั้นเรียนในวิทยาลัย",
    "SEARCH": "ค้นหา",
    "MY_BOT": "My Bot",
    "ASSIST": "ช่วยเหลือ",
    "TAB_TEXT":"ไม่มีแท็บที่เปิดใช้งาน! โปรดเปิดใช้งานอย่างน้อยหนึ่งแท็บ",
    "TRANSCRIPT": "บันทึกการสนทนา",
    "HISTORY": "ประวัติ",
    "STARTOVER": "เริ่มต้นใหม่",
    "RESTART_INPUTS": "เริ่มต้นใหม่ด้วยข้อมูลที่บันทึก",
    "ASKCUSTOMER": "ถามลูกค้า",
    "TELLCUSTOMER": "บอกลูกค้า",
    "WELCOME_MSG": "ข้อความต้อนรับ",
    "SEND": "ส่ง",
    "TAP_SEARCH":"แตะเพื่อค้นหา",
    "SENT": "ส่งแล้ว",
    "AWAITING": "รอการตอบกลับ  |  พิมพ์เพื่อดำเนินการต่อ",
    "OVERRIDE": "พิมพ์เพื่อดำเนินการต่อ",
    "OVERRIDE_FILE": "แนบไฟล์เพื่อดำเนินการต่อ",
    "ACCEPT_RESPONSE": "ตอบรับการตอบกลับ",
    "AGENT_ENTERED": "เอเจนต์เข้าร่วม",
    "EXPECTED_FORMAT": "รูปแบบที่คาดหวัง",
    "INPUT_VALUES": "ค่าข้อมูล",
    "RESTART": "เริ่มต้นใหม่",
    "START_OVER": "เริ่มต้นใหม่",
    "RESTART_CAPTURE": "เริ่มต้นใหม่ด้วยข้อมูลที่บันทึก",
    "CANCEL": "ยกเลิก",
    "INTERRUPT_DIALOG": "การสนทนาที่ถูกขัดจังหวะ",
    "RUN": "รัน",
    "RUN_AGENT": "รันด้วยข้อมูลของเอเจนต์",
    "STEP": "ขั้นตอน",
    "DIALOG_TASK": "งานการสนทนา",
    "FAQ": "คำถามที่พบบ่อย",
    "SNIPPET": "คำตอบ",
    "ARTICLE": "หน้าเว็บ",
    "FILE": "ไฟล์",
    "SUGGESTED": "แนะนำ",
    "ALL_DIALOG": "งานการสนทนาทั้งหมด",
    "DIALOG_TEXT": "การสนทนา",
    "INTENT_IDENTIFIED": "ข้อความที่พูดโดยลูกค้า",
    "NOT_WHAT_LOOKING": "คำแนะนำผิด?",
    "BOT": "บอท",
    "CUSTOMER": "ลูกค้า",
    "YOU": "คุณ",
    "TERMINATE_CONV": "ยุติงานการสนทนา",
    "TERMINATE_CONV_DESC": "คุณแน่ใจหรือไม่ว่าต้องการยุติงานการสนทนา? Agent AI จะไม่สามารถให้คำแนะนำได้อีกต่อไป",
    "YES_TERMINATE": "ใช่ ยุติ",
    "NO_CANCEL": "ไม่ ยกเลิก",
    "OVERRIDE_CONTINUE": "ดำเนินการต่อด้วยโหมดการยกเว้น",
    "SUMMARY_TEXT": "สรุป",
    "SUBMIT": "ส่ง",
    "INTERRUPT_OCCURED": "เกิดการขัดจังหวะ",
    "IDENTIFIED_INTENT": "ระบุเจตนา",
    "INTERRUPT_DESC": "การทำงานนี้จะยุติงานการสนทนาที่คุณกำลังดำเนินการอยู่",
    "ACCEPT_RUN": "ยอมรับและรัน",
    "RUN_LATER": "รันทีหลัง",
    "KNOW_MORE": "รู้เพิ่มเติม",
    "MORE_TEXT": "มากกว่า",
    "LESS_TEXT": "น้อยกว่า",
    "VIEW_MORE": "ดูเพิ่มเติม",
    "VIEW_LESS": "ดูน้อยลง",
    "SHOW_MORE_FAQ": "แสดงคำถามที่พบบ่อยเพิ่มเติม",
    "SHOW_LESS_FAQ": "แสดงคำถามที่พบบ่อยน้อยลง",
    "SHOW_MORE_ARTICLE": "แสดงหน้าเว็บเพิ่มเติม",
    "SHOW_LESS_ARTICLE": "แสดงหน้าเว็บน้อยลง",
    "SHOW_MORE_SNIPPET": "แสดงคำตอบเพิ่มเติม",
    "SHOW_LESS_SNIPPET": "แสดงคำตอบน้อยลง",
    "SHOW_MORE_FILES": "แสดงไฟล์เพิ่มเติม",
    "SHOW_LESS_FILES": "แสดงไฟล์น้อยลง",
    "VIEW_ALL_DIALOG": "ดูการสนทนาทั้งหมด",
    "VIEW_FEW_DIALOG": "ดูการสนทนาบางส่วน",
    "HELP_FULL": "มีประโยชน์ไหม?",
    "THANKYOU": "ขอบคุณ!",
    "EXPAND_MORE": "ขยาย / เพิ่มเติม",
    "CLOSE_TEXT": "ปิด",
    "STARTED": "เริ่มต้น",
    "ENDED": "สิ้นสุด",
    "VIEW_FULL_ARTICLE": "ดูหน้าเว็บ",
    "VIEW_FULL_FILE": "ดูไฟล์",
    "COPIED": "คัดลอกแล้ว",
    "SENTI_ANALY": "การวิเคราะห์อารมณ์",
    "WRONG_SUGGESTION": "คำแนะนำผิด",
    "INCORRECT_INTENT": "เจตนาผิด",
    "ACCIDENTAL_CLICK": "คลิกโดยไม่ตั้งใจ",
    "TIME_TAKING": "ใช้เวลานาน",
    "OTHER": "อื่นๆ",
    "PLAYBOOK_EMPTY_MSG": "เลือก Playbook",
    "PLAYBOOK_EMPTY_DESC": "Agent AI ไม่สามารถโหลด playbook ได้เนื่องจาก playbook ทั้งหมดที่มีอยู่เป็นแบบไดนามิก คลิก 'เลือก Playbook' เพื่อเข้าถึง playbook",
    "STAGE": "ขั้นตอน",
    "PROCEED_TO_CLOSE": "ดำเนินการปิด",
    "RECOMENDED_PLAYBOOK": "Playbook ที่แนะนำ",
    "PRIMARY_SCRIPTS": "สคริปต์หลัก",
    "DYNAMIC_SCRIPTS": "สคริปต์ไดนามิก",
    "RESUME": "ดำเนินการต่อ",
    "ENABLE_CLOSE": "คลิกที่ปุ่มดำเนินการปิดเพื่อเปิดใช้งานขั้นตอนการปิด",
    "LIST_VIEW": "มุมมองรายการ",
    "TERMINATE": "ยุติ",
    "MINIMIZE": "ย่อ",
    "MAXIMIZE": "ขยาย",
    "NO_SEARCH_RESULT": "ไม่พบผลการค้นหา",
    "SENTIMENT_AWAITING": "รอการวิเคราะห์อารมณ์",
    "POSITIVE": "บวก",
    "NEGATIVE": "ลบ",
    "ASSOCIATED_WORK_NOTES": "บันทึกการแก้ไขที่ผ่านม",
    "AGENT_JOINED_CONV": "เอเจนต์เข้าร่วมการสนทนา",
    "AUTOSCROLL_ASSIST": "ช่วยการเลื่อนอัตโนมัติเนื้อหาแท็บ",
    "FILE_SIZE_MSG": "ขนาดไฟล์ต้องอยู่ภายใน 25MB กรุณาลองใหม่อีกครั้ง",
    "OVERRIDE_BTN": "ยกเว้น",
    "CHOOSE_FILE": "เลือกไฟล์",
    "SUMMARY_ERROR_TEXT": "ขออภัย แต่เกิดปัญหาในการสร้างสรุปสำหรับการสนทนานี้ โปรดสร้างสรุปของคุณเอง",
    "ASK_A_QUESTION": "ถามคำถาม",
    "COPY": "คัดลอก",
    "TELL_US_MORE": "บอกเรามากขึ้น…",
    "THANKS_FEEDBACK": "ขอบคุณสำหรับความคิดเห็นของคุณ",
    "SOMETHING_WRONG": "มีบางอย่างผิดพลาด",
    "CLICK_ERROR_DETAILS": "คลิกเพื่อดูรายละเอียดข้อผิดพลาด",
    "NO_ACTIVE_PLAYBOOK": "ไม่มีเพลย์บุ๊กที่ใช้งานอยู่",
    "PLAYBOOK": "คู่มือเกม",
    "REPHRASE_QUESTION": "คุณสามารถพูดคำถามของคุณใหม่หรือตั้งคำถามอื่นได้ไหม?",
    "VIEW_FULL_ARTICLE_2": "ดูบทความเต็ม",
    "VIEW_FULL_FILE_2": "ดูไฟล์เต็ม",
    "INTERNAL_INFO": "ข้อมูลภายใน",
    "SOURCES": "แหล่งที่มา",
    "CONVERSATION_SUMMARY": "สรุปการสนทนา",
    "WAITING": "กำลังรอ",
    "WIDGET_DISABLED": "วิดเจ็ตถูกปิดใช้งาน",
    "AI_SETTINGS_DISABLED": "การตั้งค่า AI ถูกปิดใช้งาน! กรุณาติดต่อผู้ดูแลระบบ AI",
    "SERVER_CONNECTION_ERROR": "เกิดข้อผิดพลาดขณะเชื่อมต่อกับเซิร์ฟเวอร์",
    "VIEW": "ดู",
    "ATTACHMENT_INPUT": "ข้อมูลแนบ",
    "TYPE_SUMMARY": "พิมพ์สรุป",
    "BY":"โดย",
    GENERATE_SUMMARY: "สร้างสรุป",
    PREV_SUMMARIES: "สรุปที่สร้างไว้ก่อนหน้านี้",
    DIALOG_WORKFLOWS: "เวิร์กโฟลว์การสนทนา",
    SHOW_ALL_DIALOG: "แสดงงานการสนทนาทั้งหมด",
    SHOW_ALL_DIALOGS: "แสดงการสนทนาทั้งหมด",
    CUSTOM_TAB: "แท็บที่กำหนดเอง",
    AGENT_INPUT: "ข้อมูลของเอเจนต์",
    CUSTOM_EMPTY_MSG: "ไม่มีเวิร์กโฟลว์ที่ใช้งานอยู่",
    CUSTOM_TAB_DESC: "เพื่อเริ่มงานในเวิร์กโฟลว์ ดำเนินการหนึ่งจากรายการที่อยู่ด้านล่างของหน้าจอ",
    SUBMIT_OVERALL_FEEDBACK: "ส่งความคิดเห็นทั้งหมด",
    FEEDBACK_POPUP_SUBTITLE: "ความคิดเห็นเกี่ยวกับวิดเจ็ตและคุณสมบัติของวิดเจ็ต",
    FEEDBACK_SATISFIED: "พอใจ",
    FEEDBACK_UNSATISFIED: "ไม่พอใจ",
    FEEDBACK_PROVIDE_REASONS: "ให้ข้อมูลเพิ่มเติม…",
    FEEDBACK_TITLE: "ความคิดเห็น",
    "AGENTIC_THINKING" : "กำลังคิด",
    "AGENTIC_AGENT_TITLE" : "ตัวแทน",
    "AGENTIC_COPILOT_MODE_TITLE" : "โหมด Copilot แบบ Agentic",
    "AGENTIC_SENDING_MESSAGE" : "กำลังส่ง...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot กำลังฟังการสนทนาของคุณอย่างกระตือรือร้นและพร้อมให้ความช่วยเหลืออัตโนมัติ",
    "AGENTIC_SEARCH_RESULTS" : "ผลลัพธ์ของตัวแทน"
}
